export default "__VITE_ASSET__a35KOOLF__"